module.exports = __webpack_public_path__ + "media/images/credit_cards/credit_card-61333ad7b1ebfa12bcbd8380cc068610.gif";